// @flow
import ZonesContainer from './containers/ZonesContainer';

export default ZonesContainer;